import JoditEditor from "../../components/JoditEditor/JoditEditor";
import FullPageLoader from 'components/FullPageLoader/FullPageLoader';
import { useEffect, useState } from 'react';
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { useGetEventQuery } from '../../redux/api';
// import { uploadAdapter } from 'components/CkEditor/ckEditor';
import { Link, useParams } from 'react-router-dom';
import { ENV } from 'config/config';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const viewEvent = () => {
    const [data, setData] = useState({
        title: '',
        url: '',
        image: '',
        pageContent: '',
        shortDescription: '',
        location: '',
        eventDate: '',
        metaTitle: '',
        metaKeyword: '',
        metaDescription: '',
        isActive: true,
    })
    const [id, setId] = useState('')
    const { contentId } = useParams();

    useEffect(() => {
        window.scroll(0, 0)
        if (contentId) {
            setId(contentId)
        }
    }, [contentId])
    const { data: eventRes, isLoading: isEventLoading, isFetching: isEventFetching } = useGetEventQuery(id ? window.atob(id) : undefined, { skip: !id });
    const isGlobalLoading = isEventLoading || isEventFetching;

    useEffect(() => {}, [])

    useEffect(() => {
        if (eventRes) {
            setData(eventRes)
        }
    }, [eventRes])

    return (
        <>
            {
                isGlobalLoading ?
                    <FullPageLoader />
                    :
                    <Container>
                        <Row>
                            <Col md="12">
                                <Card className="pb-3 table-big-boy">
                                    <Card.Header>
                                        <Card.Title as="h4">View Event</Card.Title>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label>Title<span className="text-danger"> *</span></label>
                                                    <Form.Control
                                                        value={data.title ? data.title : ''}
                                                        placeholder="Title"
                                                        type="text"
                                                        disabled
                                                    ></Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">URL<span className="text-danger">*</span></label>
                                                    <Form.Control
                                                        placeholder="Enter url"
                                                        type="text"
                                                        name="url"
                                                        value={data?.url}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">Location</label>
                                                    <Form.Control
                                                        placeholder="Enter location"
                                                        type="text"
                                                        name="location"
                                                        value={data?.location}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">Event Date<span className="text-danger">*</span></label>
                                                    <div>
                                                        <DatePicker
                                                            selected={data.eventDate}
                                                            placeholderText="Select Event Date"
                                                            name="eventDate"
                                                            disabled
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md='6'>
                                                <Form.Group>
                                                    <label className="">Image<span className="text-danger">*</span></label>
                                                </Form.Group>
                                                {
                                                    id && data?.Gallery?.image && <Form.Group>
                                                        <img src={ENV.assetsUrl + "gallery/" + data?.Gallery?.image} id="imageUploader" className="image-fluid" style={{ width: '30%', height: '30%' }} alt="gallery-image" />
                                                    </Form.Group>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12" sm="6">
                                                <label>Text / Description<span className="text-danger"> *</span></label>
                                                <JoditEditor
                                                    value={data.pageContent || ''}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">Short Description</label>
                                                    <Form.Control as="textarea" rows={5}
                                                        placeholder="Enter short description"
                                                        type="text"
                                                        name="shortDescription"
                                                        value={data?.shortDescription}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">Meta Title</label>
                                                    <Form.Control
                                                        placeholder="Enter Meta tiltes"
                                                        type="text"
                                                        name="metaTitle"
                                                        value={data?.metaTitle}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">Meta Keywords</label>
                                                    <Form.Control
                                                        placeholder="Enter Meta Keywords"
                                                        type="text"
                                                        name="metaKeyword"
                                                        value={data?.metaKeyword}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <label className="">Meta Description</label>
                                                    <Form.Control
                                                        placeholder="Enter Meta Description"
                                                        type="text"
                                                        name="metaDescription"
                                                        value={data?.metaDescription}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Form.Group>
                                                    <div className='d-flex pt-3 align-items-center'>
                                                        <label className='mr-3'>Status</label>
                                                        <label className="right-label-radio mr-3 mb-2">Active
                                                            <input name="isActive" type="radio" checked={data.isActive} value={data.isActive} disabled />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                        <label className="right-label-radio mr-3 mb-2">Inactive
                                                            <input name="isActive" type="radio" checked={!data.isActive} value={!data.isActive} disabled />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12" sm="6">
                                                <div className='d-flex justify-content-end align-items-center'>
                                                    <div className='mr-2'>
                                                        <Link to={"/events"} className='outline-button btn btn-primary mt-3'>Back</Link>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
            }
        </>
    )
}

export default viewEvent;
